import { render, staticRenderFns } from "./SchneiderLogo.vue?vue&type=template&id=165cc121&functional=true&"
import script from "./SchneiderLogo.vue?vue&type=script&lang=js&"
export * from "./SchneiderLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports